// src/theme/tokens/spacing.js
// Standard 8px layout grid system
export const spacing = {
  size1:  1,
  size2:  2,
  size4:  4,
  size8:  8,
  size10: 1.25,
  size12: 12,
  size16: 16,
  size20: 20,
  size24: 24,
  size27: 27,
  size32: 32,
  size40: 40,
  size48: 48,
  size64: 64,
  size96: 96,
};

// Control heights for inputs, buttons, and interactive elements
export const controlHeights = {
  sm: 32,    // Compact: small buttons, compact inputs
  md: 38,    // Default: standard buttons and inputs
  lg: 42,    // Comfortable: large buttons and inputs
};

// Density variants for spacing and control sizes
export const density = {
  compact: {
    controlHeight: 34,
    cardPadding: 12,
    rowHeight: 44,
    spacing: {
      1: 3,
      2: 6,
      3: 9,
      4: 12,
    },
  },
  default: {
    controlHeight: 38,
    cardPadding: 16,
    rowHeight: 52,
    spacing: {
      1: 4,
      2: 8,
      3: 12,
      4: 16,
    },
  },
  comfortable: {
    controlHeight: 42,
    cardPadding: 20,
    rowHeight: 60,
    spacing: {
      1: 5,
      2: 10,
      3: 15,
      4: 20,
    },
  },
};

// Function used by MUI to calculate spacing multipliers
export const spacingFunction = (factor) => `${8 * factor}px`;
